const AVAILABLE_NETWORKS = [
  'tiktok', 'instagram', 'youtube', 'facebook', 'linkedin',
  'twitch', 'twitter', 'spotify', 'pinterest', 'blog', 'snapchat',
];

// ─── User status ────────────────────────────────────────────

export function getUserStatus(userData) {
  const isCreator = userData?.main_group?.name === 'creator';
  const hasPlan = userData?.current_plan?.name !== 'Free';
  const isBrand = userData?.main_group?.name !== 'creator';
  const isBrandPremium = isBrand && userData?.current_plan?.name === 'Premium';

  return { isCreator, hasPlan, isBrand, isBrandPremium };
}

export function isFreePlan(userData) {
  return !userData || userData?.current_plan?.name === 'Free';
}

export function hasPaidPlan(userData) {
  return !!userData && userData?.current_plan?.name !== 'Free';
}

export function isCreatorOrBrandWithPlan(userData) {
  const { isCreator, isBrand, hasPlan } = getUserStatus(userData);
  return isCreator || (isBrand && hasPlan);
}

// ─── Status texts (returns i18n keys) ───────────────────────

export function getUserStatusKeys(userData) {
  const { isCreator, isBrand, isBrandPremium, hasPlan } = getUserStatus(userData);

  const textKey = isCreator ? 'creator.textCardProposalsCreator' : isBrandPremium ? 'creator.textCardPremium' : (isBrand && hasPlan) ? 'creator.textCardBrand' : 'creator.updateMembershipToSee';

  const buttonTextKey = isCreator ? 'creator.btnCardProposals' : (isBrand && hasPlan) ? 'creator.goSearch' : 'creator.updateMembership';

  return { textKey, buttonTextKey };
}

// ─── Redirect target ────────────────────────────────────────

export const REDIRECT_EXTERNAL = 'external';
export const REDIRECT_ROUTE = 'route';
export const REDIRECT_MODAL = 'modal';

export function getRedirectTarget(userData) {
  const { isCreator, isBrand, hasPlan } = getUserStatus(userData);

  if (!userData || (!isBrand && !hasPlan)) {
    return { type: REDIRECT_MODAL };
  }
  if (isCreator) {
    return { type: REDIRECT_EXTERNAL, url: 'https://brandme.la/membresias/' };
  }
  if (isBrand && hasPlan) {
    return { type: REDIRECT_ROUTE, name: 'auth-search' };
  }
  // isBrand && !hasPlan
  return { type: REDIRECT_ROUTE, name: 'pages-account-setting', params: { section: 'membership' } };
}

// ─── Filters / query building ───────────────────────────────

export function parseFiltersFromRoute(routeQuery) {
  const filters = {};
  const networks = [];

  if (routeQuery.network) {
    networks.push(routeQuery.network);
  } else if (routeQuery.query) {
    filters.query = routeQuery.query;
  }

  if (routeQuery.banner) {
    filters.business_name = routeQuery.banner;
  }

  return { filters, networks };
}

export function buildSearchQuery(routeQuery, customFilters, networks) {
  const query = { ...customFilters };
  query.networks = networks;
  query.query = routeQuery?.query || undefined;
  return query;
}

export function filterProposalsNotShowingDoubleProposals(proposals, vanity_name) {
  return proposals.filter((proposal) => proposal.vanity_name !== vanity_name);
}

// ─── Pagination persistence ─────────────────────────────────

export function resolvePageFromHistory(routesVisited) {
  if (!Array.isArray(routesVisited) || routesVisited.length < 3) return 1;

  const routeBeforeLast = routesVisited[routesVisited.length - 2];
  if (routeBeforeLast?.name === 'view_proposals') {
    return routesVisited[routesVisited.length - 3].current_page || 1;
  }
  return 1;
}

export function savePageToHistory(routesVisited, currentPage) {
  if (!Array.isArray(routesVisited) || routesVisited.length === 0) return routesVisited;
  const updated = [...routesVisited];
  updated[updated.length - 1].current_page = currentPage;
  return updated;
}

// ─── Network helpers ────────────────────────────────────────

export function getAvailableNetworks() {
  return [...AVAILABLE_NETWORKS];
}

export function toggleNetwork(selected, net) {
  return selected.includes(net) ? selected.filter((n) => n !== net) : [...selected, net];
}

// ─── Role helper ────────────────────────────────────────────

export function getUserRole(userData) {
  return userData?.groups?.[0]?.name ?? '';
}
